import TeachingGuide from './TeachingGuide';

export default TeachingGuide;
